import React from "react";
import { Table, Tag, Button, Tooltip, Modal } from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const ItemsTable = ({ items, loading, onViewItem, onDeleteItem }) => {
  const handleDelete = (item) => {
    Modal.confirm({
      title: "Delete Item",
      content: `Are you sure you want to delete "${item.name}"? This action cannot be undone.`,
      okText: "Delete",
      okType: "danger",
      onOk: () => onDeleteItem(item.id),
    });
  };

  const columns = [
    {
      title: "Item Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <a onClick={() => onViewItem(record)}>{text}</a>
      ),
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "Category",
      dataIndex: "category_name",
      key: "category_name",
      render: (text) => text || "N/A",
    },
    {
      title: "Type",
      dataIndex: "item_type",
      key: "item_type",
      render: (type) => (
        <Tag color={type === "Required" ? "red" : "blue"}>
          {type || "Optional"}
        </Tag>
      ),
    },
    {
      title: "Has Size",
      dataIndex: "has_size",
      key: "has_size",
      align: "center",
      render: (hasSize) =>
        hasSize ? (
          <CheckCircleOutlined style={{ color: "#52c41a", fontSize: 16 }} />
        ) : (
          <CloseCircleOutlined style={{ color: "#d9d9d9", fontSize: 16 }} />
        ),
    },
    {
      title: "Has Brands",
      dataIndex: "has_brands",
      key: "has_brands",
      align: "center",
      render: (hasBrands) =>
        hasBrands ? (
          <CheckCircleOutlined style={{ color: "#52c41a", fontSize: 16 }} />
        ) : (
          <CloseCircleOutlined style={{ color: "#d9d9d9", fontSize: 16 }} />
        ),
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      render: (isActive) => (
        <Tag color={isActive === 1 ? "green" : "red"}>
          {isActive === 1 ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => (
        <div>
          <Tooltip title="View/Edit">
            <Button
              type="link"
              icon={<EditOutlined />}
              onClick={() => onViewItem(record)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <Button
              type="link"
              danger
              icon={<DeleteOutlined />}
              onClick={() => handleDelete(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={items}
      rowKey="id"
      loading={loading}
      scroll={{ x: 800 }}
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        showTotal: (total) => `Total ${total} items`,
      }}
    />
  );
};

export default ItemsTable;
